/**
 * Единые русские подписи стратегии гардероба: архетип (`WardrobeStrategyArchetype`) и уровень
 * автономии (`AutopilotLevel`). Раньше карты дублировались в `HomeAutopilotCard` и
 * `StrategyPage` и расходились, а при неизвестном коде в интерфейс утекало значение enum
 * («CAPSULE», «ASSIST» — находка QA-15 от 15.09.2026).
 *
 * Правило: код перечисления не попадает в пользовательский текст. Неизвестный код
 * получает нейтральную русскую подпись, а не сам код.
 */

/** Архетип стратегии → подпись. Ключи — `WardrobeStrategyArchetype`. */
export const ARCHETYPE_LABELS: Record<string, string> = {
    MINIMALIST: 'Минимализм',
    CAPSULE: 'Капсула',
    BUSINESS: 'Деловой',
    BUDGET: 'Бюджет',
    SPORTS: 'Спорт',
    FASHION: 'Мода',
    CUSTOM: 'Своя стратегия',
};

/** Уровень автономии → подпись. Ключи — `AutopilotLevel`. */
export const AUTOPILOT_LABELS: Record<string, string> = {
    MANUAL: 'Только советы',
    ASSIST: 'С подтверждением',
    AUTOPILOT: 'Автопилот (обратимое)',
};

/** Порядок уровней автономии от наименьшей к наибольшей — для переключателя. */
export const AUTOPILOT_LEVELS = ['MANUAL', 'ASSIST', 'AUTOPILOT'];

/** Подпись архетипа; пустой/неизвестный код — «Своя стратегия», а не сам код. */
export function archetypeLabel(code?: string | null): string {
    return (code && ARCHETYPE_LABELS[code]) || ARCHETYPE_LABELS.CUSTOM;
}

/** Подпись уровня автономии; пустой/неизвестный код — «Только советы» (безопасный минимум). */
export function autopilotLabel(code?: string | null): string {
    return (code && AUTOPILOT_LABELS[code]) || AUTOPILOT_LABELS.MANUAL;
}
